import { ILead, LeadRoutingOutcome, isDuplicateRouting } from "../../models/Lead";

/**
 * Compact table-row marker for a lead created against a vehicle another booking already held.
 * Renders nothing on an ordinary lead, so it is safe to drop into a cell unconditionally.
 *
 * Sized for the condensed lead table (text-xs), which is why it does not reuse the shared Pill.
 * The full explanation lives on the lead itself — see DuplicateVehicleBanner — so this only has to
 * be noticeable and hoverable.
 */
export default function DuplicateVehicleBadge({ lead }: { lead: ILead }) {
  if (!isDuplicateRouting(lead.routingOutcome)) return null;

  const diverted = lead.routingOutcome === LeadRoutingOutcome.DivertedDuplicateVrm;

  return (
    <span
      title={lead.routingReason ?? "Another booking already holds this vehicle."}
      className="ml-1.5 inline-flex items-center gap-1 rounded-full bg-amber-100 px-2 py-0.5 text-xs font-semibold text-amber-800 ring-1 ring-amber-300 align-middle"
    >
      <span aria-hidden="true">⚑</span>
      {diverted ? "Dup · SAV" : "Dup"}
    </span>
  );
}
